/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};
/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
    }
};
/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback, directCheckout) {
    var $body = jQuery(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                }
                else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
                if(directCheckout){
                    window.location.href ='/checkout';
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                }
                else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = jQuery(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart;

    // Private functions
    var formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function (options) {

        // Default settings
        settings = {
            formSelector       : 'form[action^="/cart/add"]',
            addToCartSelector  : 'input[type="submit"]',
            moneyFormat        : $(document.documentElement).data("moneyformat"),
            showVendor         : true
        };

        // Override defaults with arguments
        jQuery.extend(settings, options);

        // Select DOM elements
        $formContainer     = jQuery(settings.formSelector);
        $addToCart         = $formContainer.find(settings.addToCartSelector);

        // General Selectors
        $body = jQuery(document.body);

        // Track cart activity status
        isUpdating = false;

        // Take over the add to cart form submit action if ajax enabled
        if ($addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function () {
        buildCart();
    };

    formOverride = function () {
        var directCheckout = '';
        $addToCart.click(function() {
            directCheckout = $(this).hasClass('direct-checkout')
            if (directCheckout) {
                $addToCart.closest($formContainer).trigger('submit');
            }
        });
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();

            // Remove any previous quantity errors
            jQuery('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback, directCheckout);
        });
    };

    itemAddedCallback = function (product) {
        buildCart();
    };

    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');

        if (!!data.message) {
            if (data.status == 422) {
              console.log(data.description);
              var description = data.description;
              // if (description.indexOf("Alle") >= 0 && description.indexOf("in je winkelwagen") >= 0 ) {
              //   description = "Unfortunately this product is alreay sold out!";
              // }
                $formContainer.first().after('<div class="errors qty-error">'+ description +'</div>');
                if ($('.list-notifications').length == 0) {
                $body.find(".errors").insertAfter("#top");
                $body.find(".errors").wrap( "<ul class='list-notifications'><li><p class='info'></p></li></ul>" ).contents().unwrap();
                var stickyHeaderHeight = 0;
                if (!$('#top').hasClass('static') && !$('#nav').hasClass('sticky') ) {
    							stickyHeaderHeight = stickyHeaderHeight + $('#top').outerHeight();
    						}
    						if ($('#nav').hasClass('sticky')) {
    							stickyHeaderHeight = stickyHeaderHeight + $('#nav').outerHeight();
    						}
    						$('.list-notifications').scrollToFixed({
    							marginTop: stickyHeaderHeight
    						});
                $('.list-notifications').delay(6000).queue(function(){
    							$(this).slideUp().dequeue().delay(500).queue(function(){
    								$(this).remove().dequeue();
    							});
    						});
              }
            }
        }
    };

    cartUpdateCallback = function (cart) {
        buildCart(cart);
    };

    buildCart = function () {
      $.get( "/?section_id=side-cart", function( data ) {
        var cart = $(data).find('#cart');
        var totalqty = cart.find('[data-totalqty]').data('totalqty');
        $('#nav .cart .no').first().html(totalqty);
        $('#bottom .cart .no').first().html(totalqty);
        $('#cart').html(cart.html()).find('a.close').on('click', function () {
          $('html').toggleClass('cart-active');
          $('#cart').empty().addClass('loading');
          return false;
        });
        $('#cart').find('input[type="number"]').semanticNumber();
			  adjustCart();
        cartCallback();
        isUpdating = false;
        $('#cart').removeClass('loading');
      });
    };

    cartCallback = function() {
        $body.trigger('afterCartLoad.ajaxCart');
    };

    adjustCart = function () {
        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = jQuery(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        function updateQuantity(line, qty) {
            isUpdating = true;
            ShopifyAPI.changeItem(line, qty, adjustCartCallback);
        }

    };

    adjustCartCallback = function () {
        buildCart();
    };

    validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));

ajaxCart.init({
	formSelector: '.AddToCartForm',
	addToCartSelector: '.add-to-cart-button',
	moneyFormat: null,
	showVendor: false
});
$('#nav .cart a').on('click',function(){
  $('#cart').addClass('loading');
	ajaxCart.load();
});
$('body').on('click','#cartform .item-remove',function(e){
	e.preventDefault();
	$(this).parents('.sidebar-item').find('.ajaxcart__qty-num').val(0).trigger("change");
});
$('body').on('afterCartLoad.ajaxCart', function(evt) {
	$('html').addClass('cart-active');
});
